import React from "react";
import "./GlobalContactSideFilter.css";
import SimpleTextField from "../genericComponents/simpleTextField/SimpleTextField";
import { useGlobalContactSearchState } from "./GlobalContactSearchStateContext";
import EmailStatusPills from "./EmailStatusPills";
import HeadcountRangeSlider from "./HeadcountRangeSlider";
import { useState, useEffect, useRef } from "react";
import RevenueSelector from "./RangeDropdown.jsx";
import NumberRangeDropdown from "./NumberRangeDropdown.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { pxToRem } from "../../../utilities/uiUtils.js";
import { ChipsDropdown,CheckboxChipsDropdown, SearchDropdown } from "../genericComponents/uiElements/GlobalDashBoardComponents/GlobalDashBoardComponents.jsx";

function GlobalContactSideFilter() {
  const {
    domains,
    setDomains,
    orgDomains,
    setOrgDomains,
    contactEmailStat,
    setContactEmailStat,
    orgHeadCount,
    setOrgHeadCount,
    jobTitle,
    setJobTitle,
    orgRevenue,
    setOrgRevenue,
    orgJobTitles,
    setOrgJobTitles,
    seniorities,
    setSeniorities,
    personLocations,
    setPersonLocations,
    organizationLocations,
    setOrganizationLocations,
    defaultSeniorities,
    defaultLocations,
  } = useGlobalContactSearchState();
 





  const handleClearAll = () => {
    setDomains("");
    setOrgDomains("");
    setJobTitle("");
    setOrgJobTitles([]);
    setSeniorities([]);
    setPersonLocations([]);
    setOrganizationLocations([]);
    setContactEmailStat([]);
    setOrgHeadCount([]);
    setOrgRevenue([]);
  };
  return (
    <div className="gcsf-container" style={{width:pxToRem(300)} }>
      <div className="nccs-field" style={{ marginTop: "0.8rem" }}>
  <div className="gaslp_header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <h3>Contacts</h3>
    {(() => {
      const isInitialized =
        domains !== undefined &&
        orgDomains !== undefined &&
        jobTitle !== undefined &&
        orgJobTitles !== undefined &&
        seniorities !== undefined &&
        personLocations !== undefined &&
        organizationLocations !== undefined &&
        orgHeadCount !== undefined &&
        orgRevenue !== undefined &&
        contactEmailStat !== undefined;

      const hasActiveFilters =
        (domains && domains.trim() !== "") ||
        (orgDomains && orgDomains.trim() !== "") ||
        (jobTitle && jobTitle.trim() !== "") ||
        (Array.isArray(orgJobTitles) && orgJobTitles?.length > 0) ||
        (Array.isArray(seniorities) && seniorities?.length > 0) ||
        (Array.isArray(personLocations) && personLocations?.length > 0) ||
        (Array.isArray(organizationLocations) && organizationLocations?.length > 0) ||
        (Array.isArray(orgHeadCount) && orgHeadCount?.length > 0) ||
        (Array.isArray(contactEmailStat) && contactEmailStat?.length > 0) ||
        (Array.isArray(orgRevenue) && orgRevenue?.length > 0);

      const shouldShow = isInitialized && hasActiveFilters;

      return (
        <span
          onClick={handleClearAll}
          style={{
            color: "#007bff",
            cursor: "pointer",
            fontSize: "14px",
            transition: "opacity 0.25s ease, color 0.2s ease",
            opacity: shouldShow ? 1 : 0,
            visibility: shouldShow ? "visible" : "hidden",
            pointerEvents: shouldShow ? "auto" : "none",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#0056b3")}
          onMouseLeave={(e) => (e.target.style.color = "#007bff")}
        >
          Clear All
        </span>
      );
    })()}
  </div>
</div>


      <div className="nccs-field" style={{ marginTop: "1rem" }}>
        <ChipsDropdown
          selectedValues={
            jobTitle
              ? jobTitle
                  .split(",")
                  ?.map((j) => ({ id: j.trim(), label: j.trim() }))
              : []
          }
          setSelectedValues={(chips) =>
            setJobTitle(chips?.map((c) => c.label).join(","))
          }
          placeholder="Job Titles"
        />
      </div>

     
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
        <ChipsDropdown
          selectedValues={
            personLocations
              ? personLocations.map((loc) => ({ id: loc.trim(), label: loc.trim() }))
              : []
          }
          setSelectedValues={(chips) =>
            setPersonLocations(chips?.map((c) => c.label))
          }
          placeholder="Cities, States or Countries"
        />
      </div>


      {/* Seniorities Dropdown */}
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
        

        <CheckboxChipsDropdown
          options={defaultSeniorities?.map((s) => ({
            id: s,
            label: s,
          }))}
          selectedValues={seniorities?.map((s) => ({
            id: s,
            label: s,
          }))}
          setSelectedValues={(chips) =>
            setSeniorities(chips?.map((c) => c.label))
          }
          placeholder="Seniority"
        />
      </div>



      <div className="nccs-field" style={{ marginTop: "2rem" }}>
        <div className="gaslp_header">
        <h3>Companies</h3>
      </div>
      </div>


   

      {/* Company Locations Dropdown */}
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
        {/* <span className="nccs-label stf-label">Add Company Locations</span> */}

        <CheckboxChipsDropdown
          options={[
            ...new Set([...defaultLocations, ...organizationLocations]),
          ]?.map((loc) => ({
            id: loc,
            label: loc,
          }))}
          selectedValues={organizationLocations?.map((loc) => ({
            id: loc,
            label: loc,
          }))}
          setSelectedValues={(chips) =>
            setOrganizationLocations(chips?.map((chip) => chip?.label))
          }
          placeholder="HQ Location"
        />
      </div>
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
        <ChipsDropdown
          
          selectedValues={
            domains
              ? domains
                  .split(",")
                  ?.map((d) => ({ id: d.trim(), label: d.trim() }))
              : []
          }
          setSelectedValues={(chips) => {
            const domainValue = chips?.map((c) => c.label).join(",");
            setDomains(domainValue);

            // if (domainValue) {
            //   // Clear all other filters when orgDomain is selected
            //   setJobTitle("");
            //   setOrgJobTitles([]);
            //   setSeniorities([]);
            //   setPersonLocations([]);
            //   setOrganizationLocations([]);
            //   setOrgHeadCount([]);
            //   setOrgRevenue([]);

            //   setContactEmailStat([]);
            //   // setEmailStatus("");
            // }
          }}
          placeholder="Company Website"
        />
        {/* <SearchDropdown
          placeholder="Company Name"
          selectedValues={
            domains
              ? domains.split(",").map((d) => ({
                  id: d.trim(),        // website
                  label: d.trim(),     // temporary label (company name)
                }))
              : []
          }
          setSelectedValues={(chips) => {
            const domainValue = chips?.map((c) => c.id).join(","); // store website URL
            setDomains(domainValue);
          }}
        /> */}

      </div>
      
     
  {/* <div className="nccs-field" style={{ marginTop: "1rem" }}>
  <SearchDropdown
  selectedValues={
    domains
      ? domains.split(",").map((d) => ({ id: d.trim(), label: d.trim() }))
      : []
  }
  setSelectedValues={(chips) => {
    const domainValue = chips?.map((c) => c.id).join(",");
    setDomains(domainValue);

    if (domainValue) {
      // Clear other filters when a domain is selected
      setJobTitle("");
      setOrgJobTitles([]);
      setSeniorities([]);
      setPersonLocations([]);
      setOrganizationLocations([]);
      setOrgHeadCount([]);
      setOrgRevenue([]);
      setContactEmailStat([]);
    }
  }}
  placeholder="Company Domain"
/>

</div> */}



      

      <span className="nccs-field" style={{ marginTop: "1rem" }}>
        <div style={{ display: "flex", gap: "1rem" }}>
          <NumberRangeDropdown
            selectedValues={orgHeadCount}
            setSelectedValues={setOrgHeadCount}
            placeholder="Headcount Range"
          />
        </div>
      </span>
      <span className="nccs-field" style={{ marginTop: "1rem" }}>
        <div style={{ display: "flex", gap: "1rem" }}>
          <RevenueSelector
            orgRevenue={orgRevenue}
            setOrgRevenue={setOrgRevenue}
          />
        </div>
      </span>
     

      
    </div>
  );
}

export default GlobalContactSideFilter;
